<template>
	<div>
		<schema-renderer :schema="schema" @goToPage="goToPage($event)"/>
	</div>
</template>

<script>
	import SchemaRenderer from '../DynamicForm/SchemaRenderer'
	import FormRenderer from '../DynamicForm/FormRenderer'
	import objSet from 'lodash/set'
	import objGet from 'lodash/get'
	// import {mapActions, mapState} from "vuex";

	export default {
		name: 'AutoForm',
		components: {
			SchemaRenderer,
			FormRenderer, // eslint-disable-line
		},
		provide() {
			return {
				getValue: this.getValue,
				setValue: this.setValue,
				checkDependents: this.checkDependents,
				isAdmin: this.isAdmin,
				isSuperAdmin: this.isSuperAdmin,
				fieldLoaded: this.fieldLoaded,
				fieldChanged: this.fieldChanged,
			}
		},
		props: {
			schema: {
				required: true,
				type: Array,
			},
			fullSchema: {
				required: true,
				type: Array,
			},
			value: {
				required: true,
				type: Object,
			},
		},
		computed: {
			// ...mapState('user', ['userData']),
			fields() {
				return this.flatFields(this.schema);
			},
			allFields() {
				return this.flatFields(this.fullSchema);
			}
		},
		async mounted() {
			this.checkDependers();

			// await this.getUser();
		},
		methods: {
			// ...mapActions('user', ['getUser']),
			flatFields(allFields) {
				return (allFields || []).reduce((c, t) => {
					const fs = t.fields || t.children || null;
					if (fs)
						c = c.concat(fs).concat(this.flatFields(fs));

					return c;
				}, []).filter(x => !!x.id);
			},
			getValue(key) {
				// How should we handle custom values like this?
				if (key === 'product.repeat') {
					const repeat = objGet(this.value, 'product.repeat');
					const delay = objGet(this.value, 'product.repeat_delay');
					const delayType = objGet(this.value, 'product.repeat_delay_type');
					if( repeat != undefined )
						return repeat + '_' + delay + '_' + delayType;
					return undefined;
				}

				return objGet(this.value, key);
			},
			setValue(key, v) {
				let newV = {}; // only pass what changed

				// if the value is in a nested array we need the whole array passed back
				let i = key.indexOf('].');
				if (i > -1) {
					const j = key.indexOf('[');
					const parentKey = key.substr(0, j);
					const refArray = objGet(this.value, parentKey);

					if( !refArray ) return; // incase under-laying object changes for an instance

					objSet(refArray[key.substr(j + 1, i - j - 1)], key.substr(i + 2), v);
					objSet(newV, parentKey, refArray);
				} else {

					// How should we handle custom values like this?
					if (key === 'product.repeat') {
						let vals = v.split('_');
						objSet(newV, 'product.repeat', vals[0]);
						objSet(newV, 'product.repeat_delay', vals[1]);
						objSet(newV, 'product.repeat_delay_type', vals[2]);
					} else {

						// check nested object (just like array above) This only checks 1 level deep, consider recursive
						i = key.indexOf('.');
						let j = key.indexOf('.', i+1);
						if( j > -1 ) {
							const parentKey = key.substr(0, j);
							const refObj = objGet(this.value, parentKey) || {};
							objSet(refObj, key.substr(j + 1), v);
							objSet(newV, parentKey, refObj);
						} else {
							objSet(newV, key, v);
						}
					}
				}

				this.$emit('input', newV);
			},
			goToPage(pageNumber) {
				this.$emit('goToPage', pageNumber)
			},
			checkDependers() {
				// make sure current fields are being displayed based on previous field values
				let dependerIds = this.fields.reduce((c, x) => {
					if( x.dependent_settings && x.dependent_settings.groups.length ) {
						c = c.concat(x.dependent_settings.groups.map(y => y.fieldAssignmentId));
					}
					return c;
				}, []);
				[...new Set(dependerIds)].forEach((dId) => {
					const field = this.allFields.find(x => x.fieldAssignmentId === dId);
					if( field )
						this.checkDependents(dId, this.getValue(field.field_path));
				});

				// check hidden fields with no dependent settings. We want to set their default value
				const defaultHiddenFields = this.fields.filter(x => x.default_value && x.validation_settings?.originallyHidden && !x.dependent_settings?.groups?.length);
				defaultHiddenFields.forEach((field) => {
					this.setValue(field.field_path, field.default_value);
				});
			},
			checkDependents(fieldAssignmentId, value) {
				const depFields = this.allFields.filter(x => x.dependent_settings && x.dependent_settings.groups.length && !!x.dependent_settings.groups.find(y => y.fieldAssignmentId === fieldAssignmentId));

				depFields.forEach((f) => {
					f.shouldShow = false;
					let str = f.dependent_settings.groups.map((g) => {
						if (g.fieldAssignmentId !== fieldAssignmentId) {
							const checkField = this.allFields.find(x => x.fieldAssignmentId === g.fieldAssignmentId);
							return checkField ? (this.getValue(checkField?.field_path) || '').toString().toLowerCase() === (g.fieldValue || '').toString().toLowerCase() : 'false';
						} else {
							return (value || '').toString().toLowerCase() === (g.fieldValue && g.fieldValue || '').toString().toLowerCase();
						}
					}).join(f.dependent_settings.logic === 'AND' ? ' && ' : ' || ');

					if (str.length)
						f.shouldShow = eval(str);

					this.$root.$emit('fieldChanged', {field: f, attribute: 'shouldShow', value: f.shouldShow});
					if (!f.shouldShow) { // reset value
            			let value = null;
            			if( f.type === 'Money' ) // TODO:: on the field it needs a reset value
              				value = 0;
            			this.$root.$emit('fieldChanged', {field: f, attribute: 'innerValue', value});
          			}
				});

				if( value !== null )
					this.checkDefaultValues(fieldAssignmentId);
			},
			checkDefaultValues(fieldAssignmentId) { // check values of reference fields
				const fields = this.allFields.filter(x => x.fieldAssignmentId === fieldAssignmentId);
				fields.forEach((field) => {
					const depFields = this.allFields.filter(x => x.default_value && x.default_value.indexOf("{{fieldValue." + field.field_id + "}}") > -1);
					depFields.forEach((df) => {
						let fieldValue = df.default_value;
						const fieldIds = df.default_value.match(/{{fieldValue\.[0-9]+}}/g);
						const innerFields = fieldIds.map(fId => {
							const f = this.allFields.find(x => x.field_id == fId.replace("{{fieldValue.", "").replace("}}", ""));
							if( f ) f.replaceId = fId;
							return f;
						}).filter(x => !!x);
						if( innerFields.findIndex(x => !x.shouldShow) === -1 ) { // make sure all fields are visible to overwrite field
							innerFields.forEach((f) => {
								let val = this.getValue(f.field_path);
								fieldValue = fieldValue.replace(f.replaceId, val || '');
							});

							this.setValue(df.field_path, fieldValue);
						}
					});
				});
			},
			isAdmin() {
				// return !!(this.userData && this.userData.is_admin);
				return false;
			},
			isSuperAdmin() {
				return false;
			},
			fieldLoaded(fieldAssignmentId) {
				let f = this.fields.find(x => x.fieldAssignmentId == fieldAssignmentId);
				if( f )
					f.isLoaded = true;

				if( this.fields.filter(x => !x.isLoaded).length === 0 )
					setTimeout(() => {
						this.$emit('fieldsLoaded', true);
					}, 250);
			},
			fieldChanged(fieldAssignmentId, value) {
				this.$emit('fieldChanged', fieldAssignmentId);
				let f = this.fields.find(x => x.fieldAssignmentId == fieldAssignmentId);
				this.$root.$emit('fieldChanged', {field: f, value});
			}
		},
	}
</script>

<style scoped lang="scss">
	.row--dense>.col, .row--dense>[class*=col-] {
		padding: 0px !important; /*incase fields are hidden*/
	}

	.required:after {
		content: " *";
		color: red;
	}
</style>
